import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {VoipPeerApiService} from '../../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {OfflineNodeApiService} from '../../../../services/api/network/offline/node/offline-node-api.service';
import {OfflineVoipPeerApiService} from '../../../../services/api/network/offline/voip-peer/offline-voip-peer-api.service';
import {OfflineConnectionApiService} from '../../../../services/api/network/offline/connection/offline-connection-api.service';
import {OfflinePeerConnectionApiService} from '../../../../services/api/network/offline/peer-connection/offline-peer-connection-api.service';
import {DataItemToVisualsMappersOfflineService} from '../data-item-to-visuals-mappers-offline/data-item-to-visuals-mappers-offline.service';
import {OfflineNetworkApiService} from '../../../../services/api/network/offline/network/offline-network-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineMapApiService {

  constructor(private nodesApiService: NodeApiService,
              private voipPeersApiService: VoipPeerApiService,
              private connectionsApiService: ConnectionApiService,
              private peerConnectionsApiService: PeerConnectionApiService,
              private offlineNodesApiService: OfflineNodeApiService,
              private offlineVoipPeersApiService: OfflineVoipPeerApiService,
              private offlineConnectionsApiService: OfflineConnectionApiService,
              private offlinePeerConnectionsApiService: OfflinePeerConnectionApiService,
              private dataItemToVisualsMappersOffline: DataItemToVisualsMappersOfflineService,
              private offlineNetworkApiService: OfflineNetworkApiService) {
  }


  public getDataForShapes(parameters): Promise<any> {
    const mergeShapes = (dataForShapes) => {
      const shapes = [];
      let shape;

      for (const node of dataForShapes.nodes) {
        shape = {};
        shape.dataItem = _.cloneDeep(node);
        shape.id = 'node_' + node.id;
        shape.shapeType = 'node';
        shape = this.dataItemToVisualsMappersOffline.prepareShapePropertiesForDiagram(shape);
        shapes.push(shape);
      }

      for (const voipPeer of dataForShapes.voipPeers) {
        shape = {};
        shape.dataItem = _.cloneDeep(voipPeer);
        shape.id = 'voippeer_' + voipPeer.id;
        shape.shapeType = 'voipPeer';
        shape = this.dataItemToVisualsMappersOffline.prepareShapePropertiesForDiagram(shape);
        shapes.push(shape);
      }
      return shapes;
    };

    return Promise.all([this.offlineNodesApiService.getNodesForMap(parameters),
      this.offlineVoipPeersApiService.getVoipPeersForMap(parameters)]).then(data => {
      return mergeShapes({
        nodes: data[0],
        voipPeers: data[1]
      });
    });
  }

  public getDataForConnections(parameters): Promise<any> {
    const mergeConnections = (dataForConnections) => {
      const connections = [];
      let connection;

      for (const c of dataForConnections.connections) {
        connection = {};
        connection.dataItem = _.cloneDeep(c);
        connection.id = 'connection_' + c.id;
        connection.connectionType = 'connection';
        connection = this.dataItemToVisualsMappersOffline.prepareConnectionPropertiesForDiagram(connection);
        connections.push(connection);
      }
      for (const pCon of dataForConnections.pCons) {
        connection = {};
        connection.dataItem = _.cloneDeep(pCon);
        connection.id = 'peerConnection_' + pCon.id;
        connection.connectionType = 'peerConnection';
        connection = this.dataItemToVisualsMappersOffline.prepareConnectionPropertiesForDiagram(connection);
        connections.push(connection);
      }
      return connections;
    };

    return Promise.all([
      this.offlineConnectionsApiService.getConnectionsForMap(parameters),
      this.offlinePeerConnectionsApiService.getPConsForMap(parameters)])
      .then(data => {
        return mergeConnections({
          connections: data[0],
          pCons: data[1]
        });
      });
  }

  public updateShapesLocation(draggedShapes, clusters): Promise<any> {
    return Promise.all([this.offlineNodesApiService.moveNodes(draggedShapes.nodes),
      this.offlineVoipPeersApiService.moveVoipPeers(draggedShapes.voipPeers),
      this.offlineNetworkApiService.saveClustersStateToServer(clusters)]);

  }
}
